import React from 'react';
import PropTypes from 'prop-types';
import EmployeeCard from './EmployeeCard';

const EmployeeCardList = ({ employees, employeeFields, handleOpenViewModal }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {employees.map((employee) => (
        <EmployeeCard
          key={employee.id}
          employee={employee} // Use "employee" prop instead of "contact"
          employeeFields={employeeFields || []} // Use "employeeFields"
          handleOpenViewModal={handleOpenViewModal}
        />
      ))}
    </div>
  );
};

EmployeeCardList.propTypes = {
  employees: PropTypes.array.isRequired,
  employeeFields: PropTypes.array,
  handleOpenViewModal: PropTypes.func.isRequired,
};

export default EmployeeCardList;
